
export enum EquipmentEventTypeCd {
	CLOSE = 'Close',
	LOAD = 'Load',
	OPEN = 'Open'}

